<template>
  <b-col :xl="content.columns" cols="12">
    <div class="card widget-flat">
        <LmComponentLoading v-if="loading" />
        <div class="card-body">
            <div class="float-right">
                <i class="mdi widget-icon" :class="content.icon"></i>
            </div>
            <h5 class="text-muted font-weight-normal mt-0" :title="content.title">{{ content.title}}</h5>
            <h3 class="mt-3 mb-3">{{ content.number }}</h3>
            <p class="mb-0 text-muted">
                <span class="mr-2" :class="positiveNegativeText">
                  <i class="mdi" :class="positiveNegativeIcon"></i>
                  {{ content.variation_value }}
                </span>
                <span class="text-nowrap">{{ content.variation_text}}</span>
            </p>
        </div> <!-- end card-body-->
    </div> <!-- end card-->
  </b-col>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    content: {
      type: Object
    }
  },
  computed: {
    positiveNegativeText: function () {
      return {
        'text-success': this.content.variation_type === 'positive',
        'text-danger': this.content.variation_type === 'negative'
      }
    },
    positiveNegativeIcon: function () {
      return {
        'mdi-arrow-up-bold': this.content.variation_type === 'positive',
        'mdi-arrow-down-bold': this.content.variation_type === 'negative'
      }
    },
    ...mapState('settings', ['loading'])
  }
}
</script>

<style lang="sass" scoped>
  .card
    border: none
    margin-bottom: 30px
    background: white
    .widget-icon
      color: $primaryThemeColor
      font-size: 20px
      background-color: rgba(114,124,245,.25)
      height: 40px
      width: 40px
      text-align: center
      line-height: 40px
      border-radius: 3px
      display: inline-block
</style>
